export default {
  APi_URL: '/api/',
  ADDRESS_SERVICE_APi_URL: '/address_api/',
  RECAPTCHA_PUBLIC_KEY: '6LeqxEYaAAAAABlWCXTpZQJAJu72z3dP6heaIh4M',

  TABLE_ROW_COUNT: 8
}
